<template>
  <div>
    <masterList :tableColumns="tableColumns" :module="'contactCategories'" :addNew="addNew"></masterList>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import masterList from "../Components/masterList.vue";
export default {
  components: {
    masterList,
  },
  data() {
    return {
      addNew: "/settings/contact-categories/_new",
      tableColumns: [
        {
          prop: "code",
          label: "Code",
          minWidth: 100,
          sortable: true,
          key:"CODE"
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 180,
          sortable: true,
          key:"NAME"
          
        },
        {
          prop: "is_customer_dispaly",
          label: "IS_CUSTOMER",
          minWidth: 100,
          sortable: true,
          key:"IS_CUSTOMER"
        },
        {
          prop: "is_vendor_dispaly",
          label: "IS_VENDOR",
          minWidth: 100,
          sortable: true,
          key:"IS_VENDOR"
        },
        {
          prop: "is_employee_display",
          label: "IS_EMPLOYEE",
          minWidth: 100,
          sortable: true,
          key:"IS_EMPLOYEE"
        },
        {
          prop: "time_created_friendly",
          label: "TIME_CREATED",
          minWidth: 100,
          sortable: true,
          key:"TIME_CREATED"
        },
      ]
    };
  },
  mounted(){
    this.updateTableLang()
  },

  computed:{
    ...mapState({
      language_terms:(state)=>state.languages.language_terms
    })
  },

  watch:{
    language_terms:{
            handler(val){
                this.updateTableLang()
            },
        }
  },
  methods:{
      updateTableLang(){
      for(let i=0; i<this.tableColumns.length;i++){
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]

      }
    },

  }
};
</script>


<style>
</style>